// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-width {
  width: 105px;
}

.commentTextLabel {
  padding-bottom: 215px;
}

.primary {
  margin-left: 5px;
}

.secondary {
  margin-left: 5px;
}

.content-text {
  padding: 5px;
  border: 1px black solid;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
